import React, { CSSProperties, ReactElement } from 'react'
import { Image, ImageZoom } from 'Components/view-image'
import { emoji } from 'Constants/emoji'
import xss from 'xss'
import classNames from 'classnames'
import noopWrapper, { Wrapper } from 'lib/noop-wrapper'
import { size14Class, size16Class } from 'Components/new/community-card/text'

export const questionEmpty = require('static/question-empty.png')
export const forwardEmpty = require('static/forward-empty.png')

export interface IProps {
  coverUrl?: string
  errorImg?: string
  username?: string
  title?: string
  uiStyle?: number
  linkWrapper?: Wrapper
  className?: string
  style?: CSSProperties
}

const Forward: React.FC<IProps> = ({
  coverUrl,
  errorImg,
  username,
  title,
  uiStyle,
  linkWrapper = noopWrapper,
  className = 'tw-bg-common-white',
  style,
}) => {
  return linkWrapper(
    <React.Fragment>
      <div
        className={classNames(
          'tw-flex tw-mt-16 tw-py-8 tw-pl-8 tw-pr-16',
          className
        )}
        style={style}
      >
        {coverUrl ? (
          <div className="tw-flex-none tw-relative tw-mr-8">
            <Image
              width={72}
              height={72}
              src={coverUrl}
              className="tw-rounded-4 tw-w-72 tw-h-72 tw-object-cover"
              errorImg={errorImg}
              lazy={true}
              autoPixelRatio
            />
            {uiStyle === 2 ? (
              <span className="tw-absolute tw-left-24 tw-top-24 tw-w-24 tw-h-24 tw-leading-24 tw-text-center tw-bg-common-black tw-bg-opacity-50 tw-rounded-100 tw-text-white">
                <i className="DCD_Icon icon_play_1 tw-text-14" />
              </span>
            ) : null}
          </div>
        ) : null}
        <div>
          <p
            className={classNames('line-3 tw-text-justify', size14Class, {
              'tw-mt-4': coverUrl,
            })}
          >
            {username ? (
              <span className="tw-font-medium">{username}：</span>
            ) : null}
            <span
              dangerouslySetInnerHTML={{
                __html: emoji(xss.filterXSS(title || '')),
              }}
            />
          </p>
        </div>
      </div>
      <style jsx>
        {`
          p {
            line-height: 1.5;
          }
        `}
      </style>
    </React.Fragment>
  ) as ReactElement
}

export default Forward
